import get from "lodash/get";

import uiStrings from "./uistrings.json";

export const getString = (id: string, obj?: { [key: string]: any }): string => {
  let outputString = get(uiStrings, id, "");
  if (obj != null) {
    for (const key in obj) {
      const formatKey = "{{" + key + "}}";
      outputString = outputString.replace(formatKey, obj[key]);
    }
  }
  return outputString;
};

/**
 * Replaces placeholders in a text string with corresponding values from a variables object.
 * @param text - The input string containing placeholders in the format {{key}}
 * @param variables - An object with key-value pairs for placeholder replacements
 * @returns The text with placeholders replaced by their corresponding values
 **/
export const replacePlaceholders = (text: string, variables: { [key: string]: string }) => {
  return text.replace(/{{(.*?)}}/g, (_, key) => variables[key] || "");
};
